import React, { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { StyledModalAsBanner, StyledOverlay } from '@/components/Modal/Modal.styled';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';

interface IModalAsBannerProps {
  isOpen: boolean;
}

const ModalAsBanner = ({ isOpen, children }: PropsWithChildren<IModalAsBannerProps>) => {
  const { isDesktop } = useBreakpointsCtx();
  if (!isOpen) return null;

  const modalRoot = document.getElementById('modal-root');

  if (!modalRoot) return null;

  return ReactDOM.createPortal(
    <StyledOverlay isDesktop={isDesktop}>
      <StyledModalAsBanner>{children}</StyledModalAsBanner>
    </StyledOverlay>,
    modalRoot,
  );
};

export default ModalAsBanner;
